/**
 * Copyright 2025 Lumavec Group LLC
 *
 * All rights reserved. No part of this software may be used, copied, modified,
 * or distributed without explicit written permission. This software is provided
 * "as-is" without warranty of any kind, express or implied, including but not
 * limited to warranties of merchantability or fitness for a particular purpose.
 */

/**
 * Coding Agent Operations
 * 
 * Handles coding agent installation checks.
 */

import { getProductServerBaseUrl } from './base';

/**
 * Check if a coding agent CLI is installed
 * Product server endpoint - uses direct fetch
 */
export async function checkCodingAgentInstallation(agent: 'claude-code' | 'cursor' | 'gemini'): Promise<{
  success: boolean;
  installed: boolean;
  agent: string;
  command?: string;
  message?: string;
  error?: string;
}> {
  try {
    console.log('[SkillShop Service] Checking coding agent installation:', agent);

    const response = await fetch(`${getProductServerBaseUrl()}/api/coding-agents/check/${agent}`, {
      method: 'GET',
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || `Failed to check agent (${response.status})`);
    }

    const result = await response.json();
    
    console.log('[SkillShop Service] Coding agent check result:', result);
    return result;
  } catch (error: any) {
    console.error('[SkillShop Service] Error checking coding agent:', error);
    
    return {
      success: false,
      installed: false,
      agent,
      error: error.message || 'Failed to check agent installation'
    };
  }
}

